/**
 * Compliant/total/percentage for a list of companies. Compliant = status
 * 'compliant'. pct is a 0–100 integer, 0 for an empty list (no divide-by-zero).
 * Intended for the admin Dashboard filter-aware progress indicator.
 */
export function complianceCounts(companies: { status: string }[]): {
  compliant: number;
  total: number;
  pct: number;
} {
  const total = companies.length;
  const compliant = companies.filter((c) => c.status === 'compliant').length;
  const pct = total === 0 ? 0 : Math.round((compliant / total) * 100);
  return { compliant, total, pct };
}

/** Percentage of companies with `compliant` status; 0 when empty. */
export function compliancePercent(companies: { status: string }[]): number {
  return complianceCounts(companies).pct;
}
